import type { Message } from "@ai-sdk/react";
import type { QueryClient } from "@tanstack/react-query";
import { invalidateChatDetailQueries } from "@/src/utils/chatDetailInvalidateQueries";

export type SaveGoalConfirmedMessageParams = {
  toolCallId: string;
  chatId: string;
  toolName?: string;
  language: string;
  chatMode: string;
  /** tool message content；缺省时使用 `{ type: "confirmed" }` */
  payload?: Record<string, unknown>;
};

export type AppendChatMessagesFn = (
  message: Message,
  options: {
    body: {
      interactiveToolOnly?: boolean;
      messages: Message[];
    };
  },
) => Promise<string | null | undefined>;

/**
 * save_goal 确认：append 单条 tool 消息（`payload` 或默认 `{ type: "confirmed" }`）。
 */
export async function appendSaveGoalConfirmedMessages(
  append: AppendChatMessagesFn,
  params: SaveGoalConfirmedMessageParams,
): Promise<void> {
  const { toolCallId, chatId, toolName, language, chatMode, payload } = params;
  const toolContent = payload ?? { type: "confirmed" };

  const toolMessage = {
    role: "tool",
    toolCallId,
    chatId,
    content: JSON.stringify(toolContent),
    toolName,
    language,
    chatMode,
  } as unknown as Message;

  await append(toolMessage, {
    body: {
      interactiveToolOnly: true,
      messages: [toolMessage],
    },
  });
}

/**
 * save_goal confirmed：append tool 消息后刷新当前会话详情（链末执行）。
 * 供 `useChats.appendSaveGoalConfirmed` 调用；不在 confirm-save REST 后立即 invalidate。
 */
export async function appendSaveGoalConfirmedWithChatDetailSync(
  append: AppendChatMessagesFn,
  queryClient: QueryClient,
  params: SaveGoalConfirmedMessageParams,
): Promise<void> {
  await appendSaveGoalConfirmedMessages(append, params);
  invalidateChatDetailQueries(queryClient, params.chatId);
}
